import ECProductComponent from 'components/Ecommerce/ECProductComponent';
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

const ECSCRouteComponent = () => {
    const SwitchAny: any = Switch;
    const RouteAny: any = Route;
    return (
        <SwitchAny>
            <RouteAny path="/:id/:id" component={ECProductComponent} />
            <RouteAny path="/:id" component={ECProductComponent} />
        </SwitchAny>
    )
}

export default ECSCRouteComponent